export default __webpack_public_path__ + "0d41838793b124a124f8a8a4cc86c7d2.png";